import { EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import { getEnrollmentHistoryListUrl } from 'automation-ui-canvas/utils/urls';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentListFooter = ({
  flowId
}) => {
  const history = useHistory();
  const {
    search
  } = useLocation();
  const trackEvent = useTrackEvent();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const navigateBackToEnrollmentHistory = () => {
    searchParams.delete('enrollmentId');
    searchParams.delete('logEventKey');
    trackEvent(Trackables.PERFORMANCE_HISTORY_CLICKED_CHANGE_ENROLLMENT);
    history.replace({
      pathname: getEnrollmentHistoryListUrl({
        flowId
      }),
      search: searchParams.toString()
    });
  };
  return /*#__PURE__*/_jsxs(UIPanelFooter, {
    align: "center",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: 'left',
      size: 16,
      color: EERIE,
      className: "m-x-1 p-bottom-1"
    }), /*#__PURE__*/_jsx(UILink, {
      onClick: navigateBackToEnrollmentHistory,
      className: "m-all-0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.enrollmentHistory.panel.enrollment-list.footer"
      })
    })]
  });
};
export default EnrollmentListFooter;